import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { ConferenceViewModel, ConferenceViewModelWithDetails, OrganizationViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { OrganizationService } from 'src/app/_services/generatedServices';
import { OrganizationClaimsService } from 'src/app/_services/organization-claims.service';
import { NavigationService } from 'src/app/_services/navigation-service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bxl-public-paper-review',
  templateUrl: 'public-paper-review.component.html',
})
export class PublicPaperReviewComponent implements OnInit, OnDestroy {
  initialized = false;
  routeSubscription: any;
  organizationId: any;
  organization: OrganizationViewModel;
  conferenceId: string;
  conference: ConferenceViewModel;
  private authSubscription: Subscription;
  
  constructor(private route: ActivatedRoute, private orgService: OrganizationService, public auth: AuthenticationService, public claims: OrganizationClaimsService, public navService: NavigationService) {}

  ngOnInit(): void {
    if (!this.auth.isLoggedIn()) {
      this.authSubscription = this.auth.loggedIn.subscribe((loggedIn) => {
        this.authSubscription.unsubscribe();
        this.refreshClaims();
      });
    }

    this.routeSubscription = this.route.paramMap.subscribe((param) => {
      this.organizationId = param.get('organizationId');
      this.conferenceId = param.get('conferenceSlug');
      this.refreshClaims();
    });
  }

  refreshClaims() {
    this.auth.refreshClaimsAndRefreshUser().then(() => {
      this.orgService.getConferenceBySlugBasic(this.conferenceId).subscribe((conf) => {
        console.log(conf);
        this.orgService.getOrganization(conf.organizationId.toString()).subscribe((result) => {
          this.claims.OrganizationId = result.id;
          this.conference = conf;
          this.organization = result;
          this.initialized = true;
        });
      });
    });
  }

  logout() {
    this.auth.logout();
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
